<template>
    <div class="TextTab p-3">
        <a class="btn btn-block border addText mb-2 heading py-2 d-flex justify-content-center align-items-center"
            @click="addText(300, 'Add a heading', 45, 500, 20)">
            Add a heading
        </a>
        <a class="btn btn-block border addText subheading py-2 d-flex justify-content-center align-items-center"
            @click="addText(200, 'Add a subheading', 25, 100, 80)">
            Add a subheading
        </a>
        <a class="btn btn-block border addText bodytext py-2 d-flex justify-content-center align-items-center"
            @click="addText(115, 'Add a body text', 15, 400, 120)">
            Add a body text
        </a>

        <div class="my-3">
            <label class=" block text-xs font-semibold text-gray-700 uppercase tracking-widest mb-5 text-left ">font
                combinations</label>


            <div :style="{ paddingBottom: '50px' }" v-for="(ObjectItem, key) of presetList"
                v-bind:key="ObjectItem.id + key">
                <div @click="addPresetInCanvas(ObjectItem)"
                    :key="ObjectItem.id + 'TExt' + ObjectItem.animationClass + '__' + ObjectItem.animationLoop"
                    :class="`${ObjectItem.animationLoop === true ? 'animate__infinite ' + ObjectItem.animationClass : ''} ${ObjectItem.editable === false ? 'pointer ' : ''}`"
                    :style="{ ...createAnimationVar(ObjectItem.animationClass, ObjectItem.animationDuration, ObjectItem.animationDelay, 2), }"
                    v-if="ObjectItem.type === 'text'">
                    <div :key="ObjectItem.id + 'TExt222' + ObjectItem.fontfamily" :contenteditable="ObjectItem.editable"
                        class="wordbsreak select-text" v-bind:style="{
                            color: ObjectItem.color,
                            textAlign: 'center',
                            fontSize: 50 + 'px',
                            fontWeight: ObjectItem.fw,
                            fontFamily: ObjectItem.fontfamily,
                            textDecoration: ObjectItem.underline === true ? 'underline' : 'none',
                            fontStyle: ObjectItem.italic === true ? 'italic' : 'normal',
                            lineHeight: ObjectItem.lineHeight,
                            textTransform: ObjectItem.textTransform,
                            textShadow: addEffect(ObjectItem),
                            ...createHollow(ObjectItem),
                            ...createSplice(ObjectItem),
                            ...createEcho(ObjectItem),
                            ...createGlitch(ObjectItem),
                            ...createNeon(ObjectItem),
                        }">
                        <div>
                            <span>{{ ObjectItem.text[0] }}</span>
                        </div>
                    </div>


                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { v4 as uuidv4 } from 'uuid';
import { fontCombination } from "../../FontPresets";
export default {
    name: "TextTab",
    data() {
        return {
            presetList: fontCombination,
        }
    },

    computed: {
        getActiveCanvas() {
            return this.$store.getters.getCurrentActiveCanvas
        },
        getActiveCanvasZoom() {
            return this.$store.getters.getZoom
        },
    },
    methods: {
        hexToRgb(hexColor) {
            // Remove "#" from the beginning if present
            const colorString = hexColor.startsWith('#') ? hexColor.substring(1) : hexColor;

            // Parse the hexadecimal color components
            const r = parseInt(colorString.substring(0, 2), 16);
            const g = parseInt(colorString.substring(2, 4), 16);
            const b = parseInt(colorString.substring(4, 6), 16);

            // Return the RGB values as an object
            return { r: r, g: g, b: b };
        },
        adjustColorIntensity(color, intensity) {
            // Validate intensity value (should be between 0 and 100)
            if (intensity < 0 || intensity > 100) {
                throw new Error('Intensity value should be between 0 and 100');
            }

            // Convert color to HSL
            const rgb = color.match(/\w{2}/g).map(hex => parseInt(hex, 16));
            const r = rgb[0] / 255;
            const g = rgb[1] / 255;
            const b = rgb[2] / 255;

            const max = Math.max(r, g, b);
            const min = Math.min(r, g, b);
            let h, s, l = (max + min) / 2;

            if (max === min) {
                h = s = 0; // achromatic
            } else {
                const d = max - min;
                s = l > 0.5 ? d / (2 - max - min) : d / (max + min);

                switch (max) {
                    case r: h = (g - b) / d + (g < b ? 6 : 0); break;
                    case g: h = (b - r) / d + 2; break;
                    case b: h = (r - g) / d + 4; break;
                }

                h /= 6;
            }

            // Adjust lightness based on intensity
            l = l + (1 - l) * intensity / 100;
            l = Math.min(1, Math.max(0, l)); // Ensure lightness stays between 0 and 1

            // Convert back to RGB
            let rOut, gOut, bOut;

            if (s === 0) {
                rOut = gOut = bOut = l; // achromatic
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };

                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                const p = 2 * l - q;

                rOut = hue2rgb(p, q, h + 1 / 3);
                gOut = hue2rgb(p, q, h);
                bOut = hue2rgb(p, q, h - 1 / 3);
            }

            // Convert back to hex color code
            const toHex = (c) => Math.round(c * 255).toString(16).padStart(2, '0');
            const newColor = `#${toHex(rOut)}${toHex(gOut)}${toHex(bOut)}`;
            console.log("newColor")
            console.log(newColor)

            // Calculate the drop-shadow color based on intensity
            const dropShadowR = r + (1 - r) * 20 / 100;
            const dropShadowG = g + (1 - g) * 20 / 100;
            const dropShadowB = b + (1 - b) * 20 / 100;
            const dropShadowColor = `#${toHex(dropShadowR)}${toHex(dropShadowG)}${toHex(dropShadowB)}`;
            console.log("dropShadowColor")
            console.log(dropShadowColor)

            return { newcolor: newColor, dropdshadow: dropShadowColor };
        },
        createNeon(obj) {
            if (obj.effectType?.type === "neon") {
                if (obj) {
                    let createdColor = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).newcolor;
                    let dropshadow = this.adjustColorIntensity(obj.color, obj.effectType?.intensity).dropdshadow;
                    let intensity = obj.effectType?.intensity;
                    let shadow = `drop-shadow(rgba(${this.hexToRgb(dropshadow).r}, ${this.hexToRgb(dropshadow).g}, ${this.hexToRgb(dropshadow).b}, 0.95) 0px 0px ${intensity > 50 ? intensity / 45 : 65 / 45}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.75) 0px 0px ${intensity > 50 ? intensity / 13 : 65 / 13}px) drop-shadow(rgba(${this.hexToRgb(obj.color).r}, ${this.hexToRgb(obj.color).g}, ${this.hexToRgb(obj.color).b}, 0.44) 0px 0px ${intensity / 8.2}px)`
                    let filter = {
                        color: createdColor,
                        filter: shadow,
                    }
                    return filter
                }
            } else {
                return ""

            }

        },
        createGlitch(obj) {
            if (obj.effectType?.type === "glitch") {
                if (obj) {
                    let radius = obj.effectType?.offset / 15;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px rgb(0, 255, 255) , ${-(Hshadow)}px ${-(Yshadow)}px ${0}px ${color}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createEcho(obj) {
            if (obj.effectType?.type === "echo") {
                if (obj) {
                    let radius = obj.effectType?.offset / 10;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.effectType?.color.replace(')', ', 0.50)').replace('rgb', 'rgba');
                    let color2 = obj.effectType?.color.replace(')', ', 0.30)').replace('rgb', 'rgba');
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color} , ${Hshadow * 2}px ${Yshadow * 2}px ${0}px ${color2}`;
                    let echo = {
                        textShadow: shadow,
                    }
                    return echo
                }
            } else {
                return ""

            }

        },
        createSplice(obj) {
            if (obj.effectType?.type === "splice") {
                if (obj) {
                    let thickness = obj?.effectType?.thickness;
                    let radius = obj.effectType?.offset / 18;
                    let Hshadow = radius * Math.sin(Math.PI * 2 * obj.effectType?.direction / 360);
                    let Yshadow = radius * Math.cos(Math.PI * 2 * obj.effectType?.direction / 360);
                    let color = obj.color;
                    let shadow = `${Hshadow}px ${Yshadow}px ${0}px ${color}`;
                    let holow = {
                        textShadow: shadow,
                        caretColor: obj?.effectType?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.effectType?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return holow
                }
            } else {
                return ""

            }

        },
        createHollow(obj) {
            if (obj.effectType?.type === "hollow") {
                let thickness = obj?.effectType?.thickness;
                let holow = "";
                if (obj) {
                    holow = {
                        caretColor: obj?.color,
                        "-webkit-text-stroke": `${thickness / 18}px ${obj?.color}`,
                        "-webkit-text-fill-color": `transparent`,
                    }
                    return (holow)
                }

            } else {
                return ""

            }

        },
        addEffect(obj) {

            switch (obj.effectType?.type) {
                case 'shadow':
                    return this.createShadow(obj.effectType)
                case 'lift':
                    return this.createLift(obj.effectType)

                default:
                    ''
                    break;
            }

        },
        createAnimationVar(animationClass, duration, delay, motionDuration) {
            let obj = {
                '--animate-motion-duration': motionDuration * 1000 + 'ms',
                '--animate-duration': duration * 1000 + 'ms',
                '--animate-delay': delay * 1000 + 'ms',
            }
            return animationClass !== "" ? obj : {}
        },
        addPresetInCanvas(obj) {
            this.$store.dispatch("addObjectInCanvas", { ...obj, id: `text_${uuidv4()}` })
        },
        addText(width, text, fontsize, weight, top) {


            let canvas = this.getActiveCanvas;
            this.$store.dispatch("addObjectInCanvas",
                {
                    id: `text_${uuidv4()}`,
                    type: 'text',
                    text: [text],
                    top: top,
                    rotate: 0,
                    left: (canvas.size.width - width) / 2,
                    scaleX: 1,
                    scaleY: 1,
                    editable: false,
                    zoom: 1,
                    width: width,
                    color: "#565d64",
                    height: 60,
                    opacity: 1,
                    fw: weight,
                    fs: fontsize,
                    align: "center",
                    fontfamily: 'arial',
                    textTransform: "",
                    italic: false,
                    underline: false,
                    lock: false,
                    lineHeight: 1.2,
                    letterSpacing: 0,
                    effectType: { type: "none" },
                    isInAnimationActive: false,
                    isOutAnimationActive: false,
                    isLoopAnimationActive: false,
                    AnimationSequence: [],
                    animationClassIn: "",
                    animationClassOut: "",
                    animationClass: "",
                    animationClassLoop: "",
                    animationDelay: 0,
                    animationDuration: 2,
                    animationDelayIn: 0,
                    animationDurationIn: 2,
                    animationDelayOut: 0,
                    animationDurationOut: 2,
                    animationLoopDuration: 2,
                    animationLoop: false
                }
            )
        }

    }
}
</script>
<style scoped>
.addText {
    height: 45px;
    align-self: center;
    color: #495057;
}

.addText:hover {
    background-color: rgb(221 226 229);
}

.heading {
    font-weight: 900;
    font-size: 18px;
}

.subheading {
    font-weight: 500;
    font-size: 15px;
}

.bodytext {
    font-size: 13px;
}

.pointer {
    cursor: pointer;
}
</style>